import useSWR, { useSWRConfig } from 'swr';
import {
  fetchOrders,
  createOrder,
  fetchOrder,
  cancelOrders,
  paymentFinish,
} from './data-source.ts';
import { ICheckout, IOrder, IPagination } from '@shared/types.ts';
import { useUser } from '../authorization/use-user.ts';
import useSWRMutation from 'swr/mutation';
import { useSetAtom } from 'jotai';
import { productsAtom } from '../cart/use-cart-products.store.ts';
import { addToast } from '@heroui/react';

export function useOrderService({
  onOrderCreated,
  onOrders,
  orderId,
}: {
  onOrderCreated?: (value: ICheckout) => void;
  onOrders?: (value: IPagination<IOrder>) => void;
  orderId?: number;
}) {
  const setProducts = useSetAtom(productsAtom);
  const { isAuthenticated } = useUser();
  const { mutate } = useSWRConfig();

  const finish = useSWRMutation(`/api/payment/finish`, paymentFinish);

  const { isLoading, data } = useSWR(
    isAuthenticated ? `/api/orders` : null,
    fetchOrders,
    {
      onSuccess: (response) => {
        if (response && onOrders) onOrders(response);
      },
    }
  );

  const order = useSWR<IOrder | undefined>(
    orderId && isAuthenticated ? `/api/orders/${orderId}` : null,
    fetchOrder
  );

  const create = useSWRMutation(`/api/orders`, createOrder, {
    onSuccess: (data) => {
      if (data) {
        onOrderCreated?.(data);
        setProducts([]);
        finish.trigger({ order_id: `${data.order.id}` });
      }
    },
    onError: (response) => {
      if (response) {
        addToast({
          title: 'Ошибка',
          description: response?.data?.messaging ?? 'Что-то пошло не так!',
          color: 'warning',
        });
      }
    },
  });

  const cancel = useSWRMutation(`/api/orders/cancel/${orderId}`, cancelOrders, {
    onSuccess: () => mutate(`/api/orders/${orderId}`),
  });

  return { isLoading, data, create, order, cancel };
}
